export function createLoadingManager({ Loading, i18n }) {
  let loading = null;
  let needLoadingRequestCount = 0;

  function startLoading() {
    loading = Loading.service({
      lock: true,
      text: i18n.t("Common.loadTip1"),
      background: "rgba(0, 0, 0, 0.5)",
    });
  }

  function endLoading() {
    if (loading) {
      loading.close();
      loading = null;
    }
  }

  function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
      startLoading();
    }
    needLoadingRequestCount++;
  }

  function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
      endLoading();
    }
  }

  return {
    showFullScreenLoading,
    tryHideFullScreenLoading,
  };
}

